import React from 'react';
import { Skeleton, Box, Grid } from '@mui/material';

export const InspectionCardSkeleton: React.FC = () => {
    return (
        <Box
            sx={{
                width: '100%',
                borderRadius: 1,
                padding: 2,
                boxShadow: 2,
                backgroundColor: '#fff',
            }}
        >
            {/* Product */}
            <Grid container alignItems="center" spacing={2} sx={{ mb: 2 }}>
                <Grid size={3}>
                    <Skeleton variant="text" width="80%" height={30} />
                </Grid>
                <Grid size={9}>
                    <Skeleton variant="text" width="100%" height={30} />
                </Grid>
            </Grid>

            {/* Inspection Date and Total Quantity */}
            <Grid container alignItems="center" spacing={2} sx={{ mb: 2 }}>
                <Grid size={3}>
                    <Skeleton variant="text" width="80%" height={30} />
                </Grid>
                <Grid size={9}>
                    <Skeleton variant="text" width="100%" height={30} />
                </Grid>
            </Grid>

            {/* Control Point */}
            <Grid container alignItems="center" spacing={2} sx={{ mb: 2 }}>
                <Grid size={3}>
                    <Skeleton variant="text" width="80%" height={30} />
                </Grid>
                <Grid size={9}>
                    <Skeleton variant="text" width="100%" height={30} />
                </Grid>
            </Grid>
        </Box>
    );
};
